import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// KaTeX primero: los tokens del tema tienen que poder ajustarlo después.
import "katex/dist/katex.min.css";
import "./theme/tokens.css";
import "./theme/base.css";
import "./blocks/blocks.css";
import "./layout/layout.css";
import "./presets/presets.css";
import "./dev/dev.css";

import { App } from "./App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("No se encontró el contenedor #root en index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
